export function random(min, max) {
  return Math.random() * (max - min) + min
}



// WEBPACK FOOTER //
// ./src/ui/src/utils/math.js